export const PrivacyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2567_5754)">
      <path
        opacity="0.3"
        d="M8.00016 2.12665L3.3335 4.19998V7.33331C3.3335 10.3466 5.32016 13.1266 8.00016 13.9533C10.6802 13.1333 12.6668 10.3466 12.6668 7.33331V4.19998L8.00016 2.12665ZM8.66683 11.3333H7.3335V7.33331H8.66683V11.3333ZM8.66683 5.99998H7.3335V4.66665H8.66683V5.99998Z"
        fill="#56AC4A"
      />
      <path
        d="M8 2.12669L12.6667 4.20002V7.33335C12.6667 10.3467 10.68 13.1267 8 13.9534C5.32 13.1267 3.33333 10.3467 3.33333 7.33335V4.20002L8 2.12669ZM8 0.666687L2 3.33335V7.33335C2 11.0334 4.56 14.4934 8 15.3334C11.44 14.4934 14 11.0334 14 7.33335V3.33335L8 0.666687ZM7.33333 4.66669H8.66667V6.00002H7.33333V4.66669ZM7.33333 7.33335H8.66667V11.3334H7.33333V7.33335Z"
        fill="#56AC4A"
      />
    </g>
    <defs>
      <clipPath id="clip0_2567_5754">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
